import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Toast, TransactionContainer } from 'src/components/ui'

import { useSendingStars } from './hooks/useSendingStars'

const SendingStarsPage = () => {
  const { t } = useTranslation()

  const { username } = useParams()
  const { notEnoughStars, sendingStarsToUser } = useSendingStars()

  return (
    <>
      <Toast isVisible={notEnoughStars} />

      <TransactionContainer
        typeOfHeader='action'
        title={t('sending_stars.title', { username })}
        subtitle={t('sending_stars.subtitle')}
        buttonText={t('sending_stars.button_text')}
        onTransferStars={sendingStarsToUser}
        minValueForTransaction={0}
      />
    </>
  )
}

export default SendingStarsPage
